import { render, staticRenderFns } from "./EraseFab.vue?vue&type=template&id=40ae13f1&lang=pug&"
import script from "./EraseFab.vue?vue&type=script&lang=js&"
export * from "./EraseFab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "EraseFab.vue"
export default component.exports